module.exports = __webpack_public_path__ + "static/media/ld-x.42812dd8.jpg";